import { actionType } from './action';
import { IAction } from '@interface/IAction';

export const InitialState = Object.freeze({
    funder: {},
    freeCashBalance: {},
});


const reducer = (preState = InitialState, action: IAction) => {
    const { type, payload } = action;

    switch (type) {

        case actionType.SET_FUNDER_DETAIL:
            return {
                ...preState,
                funder: { ...payload }
            }

        case actionType.SET_FUNDER_AGREEMENT:
            return {
                ...preState,
                funderAgreementPath: payload
            }

        case actionType.SET_FREE_CASH_BALANCE_SUMMARY:
            return {
                ...preState,
                freeCashBalance: payload
            };

        default:
            return preState;
    }
}

export default reducer;